import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Heading3, Input } from '@treams/treams-ui';

import { WorkspaceAdvanced } from './types';

export default function WorkspaceEmailDomains(props: { workspace: WorkspaceAdvanced }) {
	const { t } = useTranslation();
	const [emailDomains, setEmailDomains] = useState(props.workspace.emailDomains ?? '');
	const [update, { loading, error }] = graphql.useUpdateWorkspaceEmailDomainsMutation();

	useEffect(() => {
		setEmailDomains(props.workspace.emailDomains ?? '');
	}, [props.workspace.emailDomains]);

	const save = useCallback(async () => {
		try {
			await update({
				variables: {
					input: {
						workspaceID: props.workspace.id,
						emailDomains: emailDomains,
					},
				},
			});
		} catch {
			// Error is handled by the error state from the mutation hook
		}
	}, [update, props.workspace.id, emailDomains]);

	return (
		<Box flexGrow={1} flexBasis={0} mt="30px">
			<Heading3 mb={2}>{t('settings.workspaces.domains.label')}</Heading3>
			{error && (
				<Box mb={2}>
					<GraphQLErrorMessage error={error.graphQLErrors?.[0] ?? error} />
				</Box>
			)}
			<Flex>
				<Input
					value={emailDomains}
					onChange={setEmailDomains}
					placeholder={t('settings.workspaces.domains.placeholder')}
					flexGrow={1}
					mr={2}
				/>
				<Button
					onClick={save}
					small
					title={t('common.save')}
					type="primary"
					flexGrow={0}
					flexShrink={0}
					disabled={loading || emailDomains === (props.workspace.emailDomains ?? '')}
				/>
			</Flex>
		</Box>
	);
}
